import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";

@Component({
  selector: "product-highlight-form",
  templateUrl: "./product-highlight-form.component.html",
  styleUrls: ["./product-highlight-form.component.scss"],
})
export class ProductHighlightFormComponent {
  @Input() form: FormGroup;

  constructor(public ft: FormToolsService) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-highlight-form/product-highlight-form.component.ts